import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from 'src/app/agent/services/agent.service';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class TeamPerformanceHandler extends BaseSearchComponent<AgentService> implements OnInit {
  @Output() closeChart = new EventEmitter<string>();
  searchName: string;
  designationObjKey: string;
  ProductionNameObjKey: string;
  productionNameArr: any = [];
  searchCriteriaData: any = {};
  kpiName: string = null;
  designationName: string = null;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
    this.searchName = 'SearchTopProducers';
  }

  ngOnInit() {
    // super.ngOnInit();
    this.service.getsubordinateDesignationRole();
    this.service.getSearchList(this.searchName, true).subscribe((response: any) => {
      const jsonData = response?.data?.searchCriteriaData || {};
      this.designationObjKey = Object.keys(jsonData).find((key) => key.includes('designation'));
      this.ProductionNameObjKey = Object.keys(jsonData).find((key) => key.includes('productionName'));
      this.getProductionName();
    });
  }

  getProductionName() {
    this.service.getProductionName().subscribe(
      (body) => {
        let lookupBody: any = body;
        this.productionNameArr = [];
        if (lookupBody['data']['values'].length > 0) {
          for (let i = 0; i < lookupBody['data']['values'].length; i++) {
            this.productionNameArr.push(lookupBody['data']['values'][i]);
            if (lookupBody['data']['values'][i]['cd'] == 'KPI_1') {
              lookupBody['data']['values'][i]['isProductionSelected'] = true;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = true;
            } else {
              lookupBody['data']['values'][i]['isProductionSelected'] = false;
              lookupBody['data']['values'][i]['isPerformanceSelected'] = false;
            }
          }
        }
        let response = JSON.parse(JSON.stringify(body));

        this.kpiName = response['data']['values'][0].cd;
        this.designationName =
          this.service.designationArr != undefined && this.service.designationArr.length != 0
            ? this.service.designationArr[0].desc
            : '';
        this.searchCriteriaData = {
          [this.ProductionNameObjKey]: this.kpiName,
        };

        this.getSearchList(this.searchName, this.searchCriteriaData);
      },
      (error) => {
        console.log('Error:', error);
        this.service.handleError(error);
      }
    );
  }

  loadSearchName(searchType) {
    if (searchType.target.value == 'T') {
      this.searchName = 'SearchTopProducers';
      this.getSearchList(this.searchName, this.searchCriteriaData);
    } else {
      this.searchName = 'SearchBottomProducers';
      this.getSearchList(this.searchName, this.searchCriteriaData);
    }
  }

  searchByProductionName(prodName) {
    this.kpiName = prodName.target.value;
    this.searchCriteriaData = {
      [this.ProductionNameObjKey]: prodName.target.value,
      [this.designationObjKey]: this.designationName,
    };
  }

  searchByDesignation(des, data) {
    data.filter((item) => {
      if (des.target.value == item.designationDescription) {
        this.designationName = item.designationCd;
        this.searchCriteriaData = {
          [this.ProductionNameObjKey]: this.kpiName,
          [this.designationObjKey]: item.designationCd,
        };
      }
    });
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit();
  }

  getSearchList(searchName, searchCriteriaData?) {
    this.service.getSearchList(searchName, true, searchCriteriaData).subscribe(
      (response: any) => {
        // console.log('Get search list successful.');
      },
      (error) => {
        console.log('Error:', error);
      }
    );
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    // super.ngOnDestroy();
    this.service.clear();
  }
}
